<template>
  <div>
    <div
      class="flex flex-row justify-between items-center text-lg cursor-pointer"
      @click="toggleItem(indexOf)"
    >
      <h4 v-if="accordion.question" class="text-base font-bold">
        {{ accordion.question }}
      </h4>
      <p v-text="showIndex === indexOf ? '-' : '+'" class="my-auto"></p>
    </div>
    <transition name="fade">
      <div v-if="showIndex === indexOf" class="pt-3 max-w-full text-base prose" v-html="accordion.answer">
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: "Accordion",
  props: ["accordion"],
  data() {
    return {
      showIndex: null, // Initialize showIndex
    };
  },
  methods: {
    toggleItem(indexOf) {
      if (this.showIndex === indexOf) {
        this.showIndex = null; // Close the current open item
      } else {
        this.showIndex = indexOf; // Open the clicked item
      }
    },
  },
};
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.9s ease-in-out, height 0.9s ease-in-out; /* Adjust timing function */
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
